import { render, staticRenderFns } from "./BouncyLoader.vue?vue&type=template&id=bf274918&scoped=true"
import script from "./BouncyLoader.vue?vue&type=script&lang=ts"
export * from "./BouncyLoader.vue?vue&type=script&lang=ts"
import style0 from "./BouncyLoader.vue?vue&type=style&index=0&id=bf274918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf274918",
  null
  
)

export default component.exports